export const CRON_CREATED = "s0175";
export const CRON_CREATE_ERROR = "e0175";
export const CRON_UPDATED = "s0176";
export const CRON_UPDATE_ERROR = "e0176";
export const CRON_TURNED_ON = "s0177";
export const CRON_TURN_ON_ERROR = "e0177";
export const CRON_TURNED_OFF = "s0178";
export const CRON_TURN_OFF_ERROR = "e0178";
export const CRON_REMOVED = "s0179";
export const CRON_REMOVE_ERROR = "e0179";

export const cron = {
    [CRON_CREATED]: {
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [CRON_UPDATED]: {
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [CRON_REMOVED]: {
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [CRON_TURNED_ON]: {
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [CRON_TURNED_OFF]: {
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [CRON_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_cron",
        icon: "/img/storage.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.crons.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.cron.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.cron"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.cron")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    }
}; 